import clsx from 'clsx';
import { CheckBoxSquareIcon, CheckBoxActiveSquareIcon } from '@/components/icons/svg-icons';

interface LabelCheckButtonProps {
	selected: boolean;
	disabled?: boolean;
	onClick: (event: React.MouseEvent) => void;
	children: React.ReactNode;
	className?: string;
}

export const LabelCheckButton = ({ selected, disabled = false, onClick, children, className }: LabelCheckButtonProps) => {
	return (
		<label 
			className={clsx('checkbox select-league__item', className)}
			data-selected={selected}
			data-disabled={disabled}
			onClick={onClick}
		>
			<input type="checkbox" />

			{selected ? <CheckBoxActiveSquareIcon /> : <CheckBoxSquareIcon />}
			
			<span className="checkbox__text">{children}</span>
		</label>
	);
};